// @flow
import React from 'react';

import { StyledExternalLink } from '../presentational/ExternalLink';

const CONNECT_MODELER_LINK =
  'https://docs.google.com/spreadsheets/d/1Yv2rJTNFC-w-yNut77ARK-6cwe-ZDrQKluslrsXrBGs/edit?gid=1266307975#gid=1266307975';
const TIERED_DISCOUNTS_LINK =
  'https://docs.google.com/presentation/d/1Z3Y0zqabfyIEe0CIYokXyeIgkbIwtxBjO-UbED1ILiI/edit';

export const CLUSTER_MAPPING_TABLE_FROM_OLD_TO_NEW = {
  headerRow: [
    'FROM: 8/1, 10/1, 3/5 (Base + Partition)',
    'TO: 4/11, 8/14/2025 or 5/15/2026 (eCKU based RC)',
    'Note',
  ],
  dataRows: [
    [
      <>Basic, SZ, 99.5%</>,
      <>
        Basic, MZ, 99.5%
        <br />
        Min eCKU - 1
      </>,
      <>SZ → MZ</>,
    ],
    [
      <>
        Standard, SZ, 99.95%
        <br />
        Standard, MZ, 99.99%
      </>,
      <>
        Standard, MZ, 99.99%
        <br /> <strong>Min eCKUs - 2</strong>
      </>,
      <>
        SZ → MZ
        <br />
        Existing Standard SZ clusters will map to MZ, 99.99%
        <br />
        <strong>This means Standard pricing will remain $1.5/hr</strong>
      </>,
    ],
  ],
};

export const CLUSTER_MAPPING_TABLE_FROM_NEW_TO_OLD = {
  headerRow: [
    'FROM: 4/11, 8/14/2025 or 5/15/2026 (eCKU based RC)',
    'TO: 8/1, 10/1, 3/5 (Base + Partition)',
    'Note',
  ],
  dataRows: [
    [
      <>
        Basic, MZ, 99.5%
        <br />
        Min eCKU - 1
      </>,
      <>Basic, SZ, 99.5%</>,
      <>MZ → SZ</>,
    ],
    [
      <>
        Standard, MZ, 99.9%
        <br />
        Standard, MZ, 99.99%
      </>,
      <>Standard, MZ, 99.99%</>,
      <>
        MZ is maintained
        <br />
        <strong>This means Standard 1 eCKU pricing will increase from $0.75/hr to $1.5/hr.</strong>
      </>,
    ],
  ],
};

export const CONNECT_AND_TABLEFLOW_PRICING_CHANGES_TABLE = {
  headerRow: ['FROM: All other rate cards', 'TO: 5/15/2026 (Tiered pricing rate card)', 'Note'],
  dataRows: [
    [
      <>
        Connect Tasks (7 price points starting from $0.0347 to $3.0)
        <br />- Volume-based discounts
      </>,
      <>
        4 price points - $0.05, $0.10, $0.30 and $3.0 per tasks{' '}
        <strong>
          <em>plus</em>
        </strong>
        <br />- <StyledExternalLink href={TIERED_DISCOUNTS_LINK} text="Tiered discounts" />
      </>,
      <>
        Check out this{' '}
        <StyledExternalLink href={CONNECT_MODELER_LINK} text="internal connect modeler" /> to find
        the price change for each connector type
      </>,
    ],
    [
      <>
        Tableflow Topic - $0.10
        <br />- Volume-based discounts
      </>,
      <>
        Tableflow Topic - $0.10
        <br />- <StyledExternalLink href={TIERED_DISCOUNTS_LINK} text="Tiered discounts" />
      </>,
      <>No change in topic price</>,
    ],
  ],
};
